module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/graf-pill.595aee5e.svg";